async function stall(stallTime = 3000) {
    await new Promise(resolve => setTimeout(resolve, stallTime));
  }

export default stall;